import { quosaTags as knownQuosaTags } from "./quosaTags";
import { tags as knownRisTags } from "./tags";
import { runQuosaValidationsFor, runValidationsFor } from "./tagValidations";
export const tokensToRisItems = ({ ctx, tokens, errors }) => {
    const risItems = [];
    while (tokens === null || tokens === void 0 ? void 0 : tokens.length) {
        const risItem = ctx.mode === 'quosa'
            ? consumeQuosaRisItem({ tokens, errors })
            : consumeRisItem({ tokens, errors });
        if (risItem)
            risItems.push(risItem);
    }
    return risItems;
};
const consumeRisItem = ({ tokens, errors }) => {
    const risItem = {
        type: 'item',
        tags: [],
        endLocation: 0,
        startLocation: 0,
    };
    let token = tokens.shift();
    if (!token)
        return;
    if (token.type !== 'ris_tuple')
        return;
    if (token.tag.name !== 'TY') {
        errors.push({
            severity: 'warning',
            message: `Expected TY tag, got ${token.tag.name} ${token.tag.line}:${token.tag.column}`,
            line: token.tag.line,
            column: token.tag.column,
        });
        return;
    }
    risItem.startLocation = token.tag.startPosition;
    let tagDescription = knownRisTags[token.tag.name] || "";
    if (tagDescription === "") {
        errors.push({
            severity: 'warning',
            message: `Unknown tag "${token.tag.name}" ${token.tag.line}:${token.tag.column}`,
            line: token.tag.line,
            column: token.tag.column,
        });
    }
    risItem.tags.push({
        type: 'tag',
        tag: token.tag.name,
        tagDescripton: tagDescription,
        content: token.fieldValue.value,
        line: token.tag.line,
        column: token.tag.column,
    });
    do {
        token = tokens.shift();
        if ((token === null || token === void 0 ? void 0 : token.type) != 'ris_tuple')
            break;
        tagDescription = knownRisTags[token.tag.name] || "";
        if (tagDescription === "") {
            errors.push({
                severity: 'warning',
                message: `Unknown tag "${token.tag.name}" ${token.tag.line}:${token.tag.column}`,
                line: token.tag.line,
                column: token.tag.column,
            });
        }
        risItem.tags.push({
            type: 'tag',
            tag: token.tag.name,
            tagDescripton: tagDescription,
            content: token.fieldValue.value,
            line: token.tag.line,
            column: token.tag.column,
        });
        risItem.endLocation = token.tag.endPosition;
        if (token.tag.name === 'ER')
            break;
    } while (token);
    risItem
        .tags
        .forEach(tag => runValidationsFor({ tag, errors }));
    return risItem;
};
const consumeQuosaRisItem = ({ tokens, errors }) => {
    const risItem = {
        type: 'item',
        tags: [],
        endLocation: 0,
        startLocation: 0,
    };
    let token = tokens.shift();
    if (!token)
        return;
    if (token.type !== 'ris_tuple')
        return;
    let tagDescription = knownQuosaTags[token.tag.name] || knownRisTags[token.tag.name] || "";
    if (tagDescription === "") {
        errors.push({
            severity: 'warning',
            message: `Unknown tag "${token.tag.name}" ${token.tag.line}:${token.tag.column}`,
            line: token.tag.line,
            column: token.tag.column,
        });
    }
    risItem.tags.push({
        type: 'tag',
        tag: token.tag.name,
        tagDescripton: tagDescription,
        content: token.fieldValue.value,
        line: token.tag.line,
        column: token.tag.column,
    });
    do {
        token = tokens.shift();
        if ((token === null || token === void 0 ? void 0 : token.type) != 'ris_tuple')
            break;
        tagDescription = knownQuosaTags[token.tag.name] || knownRisTags[token.tag.name] || "";
        if (tagDescription === "") {
            errors.push({
                severity: 'warning',
                message: `Unknown tag "${token.tag.name}" ${token.tag.line}:${token.tag.column}`,
                line: token.tag.line,
                column: token.tag.column,
            });
        }
        risItem.tags.push({
            type: 'tag',
            tag: token.tag.name,
            tagDescripton: tagDescription,
            content: token.fieldValue.value,
            line: token.tag.line,
            column: token.tag.column,
        });
    } while (token);
    risItem
        .tags
        .forEach(tag => runQuosaValidationsFor({ tag, errors }));
    return risItem;
};
